import { useState } from 'react';
import { Pill } from 'lucide-react';

/** Displays the configured shop logo, with the existing pill mark as a fallback. */
export default function PharmacyLogo({ logo, alt = 'Shop logo', className = '', imageClassName = '' }) {
  const [failed, setFailed] = useState(false);

  if (logo && !failed) {
    return (
      <img
        src={logo}
        alt={alt}
        className={imageClassName || className}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div className={`flex items-center justify-center bg-emerald-500 ${className}`} aria-label={alt}>
      <Pill className="h-5 w-5 text-white" />
    </div>
  );
}
